export default {
  'en-GB': {

    // PageNotFound
    pageNotFoundTitle: 'Oops! Nothing was found',
    pageNotFoundText: 'The page you are looking for might have been removed had its name changed or is temporarily unavailable.',
    pageNotFoundHomePage: 'Return to homepage',

    // NavBar
    navBarListContacts: 'Contact List',
    navBarAddContact: 'Add Person',
    navBarAddOrganization: 'Add Organization',
    navBarPickLanguage: 'Language',
    navBarUser: 'User',
    navBarProfile: 'Profile',
    changePassword: 'Change password',
    navBarSignOut: 'Sign Out',
    profileTitle: 'User profile',
    profileFirstName: 'First name',
    profileLastName: 'Last name',
    profileEmail: 'Email',
    profileRoles: 'Roles',
    profileNoRoles: 'No roles',
    close: 'Close',

    settings: {
      menu: 'Settings',
      title: 'Settings',
      description: 'Configure how the application behaves.',
      loading: 'Loading settings…',
      save: 'Save',
      cancel: 'Cancel',
      sections: {
        supplements: {
          title: 'Supplements',
          description: 'Operation and analysis supplements that can be added to offers and treatments. Deactivating a supplement only stops it from being offered: existing offers, treatments and invoices keep it.',
          add: 'Add a supplement',
          edit: 'Edit the supplement',
          deactivate: 'Deactivate',
          reactivate: 'Reactivate',
          deactivateConfirmation: 'Deactivate "{name}"? It will no longer be offered in new offers and treatments. Existing ones are not affected.',
          search: 'Search by name or reference…',
          showInactive: 'Show deactivated',
          empty: 'No supplement found.',
          type: 'Type',
          types: { ALL: 'All', OPERATION: 'Operation', ANALYSIS: 'Analysis' },
          internalRef: 'Internal reference',
          internalRefLocked: 'The internal reference cannot be changed once created.',
          internalRefAnalysisHelp: 'Required. It is matched with the analysed elements in treatments and cannot be changed later.',
          internalRefOptional: 'Optional. It cannot be changed later.',
          internalRefRequired: 'The internal reference is required for an analysis supplement.',
          name: 'Name',
          nameRequired: 'A name is required.',
          descriptionLabel: 'Description',
          price: 'Price',
          priceHelp: 'Only applies to offers created from now on: existing offers keep their own price.',
          priceInvalid: 'Enter a price of 0 or more.',
          units: 'Units',
          unitsRequired: 'Select at least one unit.',
          status: 'Status',
          active: 'Active',
          inactive: 'Deactivated',
          duplicateRef: 'A supplement with this internal reference already exists.',
          forbidden: 'You are not allowed to edit supplements.',
          loadError: 'The supplements could not be loaded.',
          saveError: 'The supplement could not be saved.',
          deactivateError: 'The supplement could not be deactivated.',
          reactivateError: 'The supplement could not be reactivated.'
        },
        reindexing: {
          title: 'Reindexing',
          description: 'Rebuilds the search indexes of a module from its database. Use it after data was changed directly in the database or after a change in how data is indexed. Lists and filters of the module can be incomplete while it runs.',
          module: 'Module',
          status: 'Status',
          reindex: 'Reindex',
          reindexAll: 'Reindex all',
          done: 'Done',
          error: 'Failed',
          confirmation: 'Reindex "{module}"? Its lists and filters can be incomplete for a moment.',
          confirmationAll: 'Reindex all modules, one after the other? Lists and filters can be incomplete for a moment.',
          modules: {
            contacts: 'Contacts',
            offers: 'Offers',
            transports: 'Transports and planning',
            treatments: 'Entries, analyses and certificates',
            preInvoices: 'Pre-invoices',
            invoices: 'Invoices',
            exits: 'Exits and flows'
          }
        },
        email: {
          title: 'Email',
          description: 'SMTP server and recipient redirection used for every email sent by the application (invoices, certificates…).',
          notConfigured: 'No settings saved yet: the application still uses the configuration of each module.',
          smtp: 'SMTP server',
          host: 'Server',
          port: 'Port',
          auth: 'The server requires authentication',
          startTls: 'Use STARTTLS',
          username: 'Username',
          password: 'Password',
          passwordKept: 'Leave empty to keep the current password.',
          from: 'Sender address',
          bcc: 'Blind copy (BCC)',
          addressesHelp: 'One address per line (or separated by commas).',
          redirection: 'Email redirection',
          redirectEnabled: 'Redirect all emails to the addresses below',
          redirectWarning: 'While the redirection is active, no email reaches the real recipients (customers, contacts…).',
          redirectTo: 'Redirect to',
          redirectRequired: 'At least one address is required when the redirection is active.',
          lastUpdate: 'Last update: {date} by {user}',
          saved: 'The email settings have been saved.',
          saveError: 'The email settings could not be saved.',
          loadError: 'The email settings could not be loaded.',
          test: 'Send a test message',
          testDescription: 'Uses the values currently shown above, even if they are not saved yet. The redirection is not applied to test messages.',
          testRecipient: 'Recipient of the test message',
          sendTest: 'Send',
          testSent: 'Test message sent to {to}.',
          testFailed: 'The test message could not be sent: {reason}',
          testError: 'The test message could not be sent.'
        }
      }
    },

    announcements: {
      bannerLabel: 'Important announcements',
      administration: 'Manage announcements',
      title: 'Announcements',
      description: 'Publish information, maintenance notices, and product updates for all users.',
      add: 'New announcement',
      edit: 'Edit announcement',
      delete: 'Delete announcement',
      save: 'Save',
      cancel: 'Cancel',
      dismiss: 'Dismiss announcement',
      message: 'Message',
      messageRequired: 'A message is required.',
      linkLabel: 'Link text (optional)',
      linkUrl: 'Link URL (optional)',
      linkLabelRequired: 'Enter the text to display for this link.',
      linkUrlInvalid: 'Enter a valid HTTP or HTTPS URL.',
      type: 'Type',
      startsAt: 'Display from',
      endsAt: 'Display until',
      date: 'Date',
      time: 'Time',
      selectNow: 'Now',
      invalidPeriod: 'The end must be later than the start.',
      publish: 'Publish this announcement',
      period: 'Display period',
      status: 'Status',
      actions: 'Actions',
      published: 'Published',
      draft: 'Draft',
      loading: 'Loading announcements…',
      empty: 'No announcements have been created yet.',
      always: 'Always',
      now: 'Now',
      noEnd: 'No end date',
      loadError: 'The announcements could not be loaded.',
      saveError: 'The announcement could not be saved.',
      deleteError: 'The announcement could not be deleted.',
      deleteConfirmation: 'Are you sure you want to delete this announcement?',
      types: {
        info: 'Information',
        success: 'Update',
        warning: 'Warning',
        danger: 'Critical'
      }
    },

    page: {
      title: {
        contacts: 'Contacts',
        offers: 'Offers',
        plannings: 'Planning',
        treatments: 'Entries',
        analyses: 'Analyses',
        'pre-invoices': 'Pre-invoices',
        invoices: 'Invoices',
        entries:'Entries',
        exits: 'Exits',
        flow: 'Flow',
        exitprocess: 'Exits',
        certificates: 'Certificates',
        'announcement-administration': 'Announcements',
        settings: 'Settings'
      }
    },

    // Footer
    poweredBy: 'powered by',

    SITE_ENGIS_DIVISION: 'Division Engis',
    SITE_MONSIN_DIVISION: 'Division Monsin',
    ENTRIES_PROCESS: 'Entries',
    EXITS_PROCESS: 'Exits'
  },
  'fr-FR': {

    // PageNotFound
    pageNotFoundTitle: 'Oups! Page non trouvée',
    pageNotFoundText: 'La page que vous essayez d\'accéder n\'existe plus ou est temporairement inaccessible.',
    pageNotFoundHomePage: 'Retour vers l\'accueil',

    // NavBar
    navBarListContacts: 'Liste des Contacts',
    navBarAddContact: 'Ajouter une personne',
    navBarAddOrganization: 'Ajouter une organisation',
    navBarPickLanguage: 'Langue',
    navBarUser: 'Utilisateur',
    navBarProfile: 'Profil',
    changePassword: 'Changer de mot de passe',
    navBarSignOut: 'Se Déconnecter',
    profileTitle: 'Profil utilisateur',
    profileFirstName: 'Prénom',
    profileLastName: 'Nom',
    profileEmail: 'E-mail',
    profileRoles: 'Rôles',
    profileNoRoles: 'Aucun rôle',
    close: 'Fermer',

    settings: {
      menu: 'Paramètres',
      title: 'Paramètres',
      description: 'Configurez le comportement de l\'application.',
      loading: 'Chargement des paramètres…',
      save: 'Enregistrer',
      cancel: 'Annuler',
      sections: {
        supplements: {
          title: 'Suppléments',
          description: 'Suppléments d\'opération et d\'analyse proposés dans les offres et les traitements. Désactiver un supplément l\'empêche seulement d\'être proposé : les offres, traitements et factures existants le conservent.',
          add: 'Ajouter un supplément',
          edit: 'Modifier le supplément',
          deactivate: 'Désactiver',
          reactivate: 'Réactiver',
          deactivateConfirmation: 'Désactiver « {name} » ? Il ne sera plus proposé dans les nouvelles offres et les nouveaux traitements. Les existants ne sont pas modifiés.',
          search: 'Rechercher par nom ou référence…',
          showInactive: 'Afficher les désactivés',
          empty: 'Aucun supplément trouvé.',
          type: 'Type',
          types: { ALL: 'Tous', OPERATION: 'Opération', ANALYSIS: 'Analyse' },
          internalRef: 'Référence interne',
          internalRefLocked: 'La référence interne ne peut plus être modifiée après la création.',
          internalRefAnalysisHelp: 'Obligatoire. Elle est mise en correspondance avec les éléments analysés dans les traitements et ne pourra plus être modifiée.',
          internalRefOptional: 'Facultative. Elle ne pourra plus être modifiée.',
          internalRefRequired: 'La référence interne est obligatoire pour un supplément d\'analyse.',
          name: 'Nom',
          nameRequired: 'Un nom est requis.',
          descriptionLabel: 'Description',
          price: 'Prix',
          priceHelp: 'S\'applique uniquement aux offres créées à partir de maintenant : les offres existantes gardent leur prix.',
          priceInvalid: 'Saisissez un prix supérieur ou égal à 0.',
          units: 'Unités',
          unitsRequired: 'Sélectionnez au moins une unité.',
          status: 'Statut',
          active: 'Actif',
          inactive: 'Désactivé',
          duplicateRef: 'Un supplément avec cette référence interne existe déjà.',
          forbidden: 'Vous n\'avez pas le droit de modifier les suppléments.',
          loadError: 'Les suppléments n\'ont pas pu être chargés.',
          saveError: 'Le supplément n\'a pas pu être enregistré.',
          deactivateError: 'Le supplément n\'a pas pu être désactivé.',
          reactivateError: 'Le supplément n\'a pas pu être réactivé.'
        },
        reindexing: {
          title: 'Réindexation',
          description: 'Reconstruit les index de recherche d\'un module à partir de sa base de données. À utiliser après une modification directe en base ou un changement de la façon dont les données sont indexées. Les listes et filtres du module peuvent être incomplets pendant l\'opération.',
          module: 'Module',
          status: 'Statut',
          reindex: 'Réindexer',
          reindexAll: 'Tout réindexer',
          done: 'Terminé',
          error: 'Échec',
          confirmation: 'Réindexer « {module} » ? Ses listes et filtres peuvent être incomplets un instant.',
          confirmationAll: 'Réindexer tous les modules, l\'un après l\'autre ? Les listes et filtres peuvent être incomplets un instant.',
          modules: {
            contacts: 'Contacts',
            offers: 'Offres',
            transports: 'Transports et planning',
            treatments: 'Entrées, analyses et certificats',
            preInvoices: 'Préfactures',
            invoices: 'Factures',
            exits: 'Sorties et flux'
          }
        },
        email: {
          title: 'E-mail',
          description: 'Serveur SMTP et redirection des destinataires utilisés pour tous les e-mails envoyés par l\'application (factures, certificats…).',
          notConfigured: 'Aucun paramètre enregistré : l\'application utilise encore la configuration de chaque module.',
          smtp: 'Serveur SMTP',
          host: 'Serveur',
          port: 'Port',
          auth: 'Le serveur requiert une authentification',
          startTls: 'Utiliser STARTTLS',
          username: 'Nom d\'utilisateur',
          password: 'Mot de passe',
          passwordKept: 'Laissez vide pour conserver le mot de passe actuel.',
          from: 'Adresse de l\'expéditeur',
          bcc: 'Copie cachée (BCC)',
          addressesHelp: 'Une adresse par ligne (ou séparées par des virgules).',
          redirection: 'Redirection des e-mails',
          redirectEnabled: 'Rediriger tous les e-mails vers les adresses ci-dessous',
          redirectWarning: 'Tant que la redirection est active, aucun e-mail n\'atteint les vrais destinataires (clients, contacts…).',
          redirectTo: 'Rediriger vers',
          redirectRequired: 'Au moins une adresse est requise lorsque la redirection est active.',
          lastUpdate: 'Dernière modification : {date} par {user}',
          saved: 'Les paramètres e-mail ont été enregistrés.',
          saveError: 'Les paramètres e-mail n\'ont pas pu être enregistrés.',
          loadError: 'Les paramètres e-mail n\'ont pas pu être chargés.',
          test: 'Envoyer un message de test',
          testDescription: 'Utilise les valeurs affichées ci-dessus, même non enregistrées. La redirection n\'est pas appliquée aux messages de test.',
          testRecipient: 'Destinataire du message de test',
          sendTest: 'Envoyer',
          testSent: 'Message de test envoyé à {to}.',
          testFailed: 'Le message de test n\'a pas pu être envoyé : {reason}',
          testError: 'Le message de test n\'a pas pu être envoyé.'
        }
      }
    },

    announcements: {
      bannerLabel: 'Annonces importantes',
      administration: 'Gérer les annonces',
      title: 'Annonces',
      description: 'Publiez des informations, des maintenances et des nouveautés pour tous les utilisateurs.',
      add: 'Nouvelle annonce',
      edit: 'Modifier l\'annonce',
      delete: 'Supprimer l\'annonce',
      save: 'Enregistrer',
      cancel: 'Annuler',
      dismiss: 'Fermer l\'annonce',
      message: 'Message',
      messageRequired: 'Un message est requis.',
      linkLabel: 'Texte du lien (facultatif)',
      linkUrl: 'URL du lien (facultative)',
      linkLabelRequired: 'Saisissez le texte à afficher pour ce lien.',
      linkUrlInvalid: 'Saisissez une URL HTTP ou HTTPS valide.',
      type: 'Type',
      startsAt: 'Afficher à partir du',
      endsAt: 'Afficher jusqu\'au',
      date: 'Date',
      time: 'Heure',
      selectNow: 'Maintenant',
      invalidPeriod: 'La fin doit être postérieure au début.',
      publish: 'Publier cette annonce',
      period: 'Période d\'affichage',
      status: 'Statut',
      actions: 'Actions',
      published: 'Publiée',
      draft: 'Brouillon',
      loading: 'Chargement des annonces…',
      empty: 'Aucune annonce n\'a encore été créée.',
      always: 'Toujours',
      now: 'Maintenant',
      noEnd: 'Sans date de fin',
      loadError: 'Impossible de charger les annonces.',
      saveError: 'Impossible d\'enregistrer l\'annonce.',
      deleteError: 'Impossible de supprimer l\'annonce.',
      deleteConfirmation: 'Voulez-vous vraiment supprimer cette annonce ?',
      types: {
        info: 'Information',
        success: 'Nouveauté',
        warning: 'Avertissement',
        danger: 'Critique'
      }
    },

    page: {
      title: {
        contacts: 'Contacts',
        offers: 'Offres',
        plannings: 'Planning',
        treatments: 'Entrées',
        analyses: 'Analyses',
        'pre-invoices': 'Pré-factures',
        invoices: 'Factures',
        entries:'Entrées',
        exits: 'Sorties',
        flow: 'Flux',
        exitprocess: 'Sorties',
        certificates : 'Certificats',
        'announcement-administration': 'Annonces',
        settings: 'Paramètres'
      }
    },

    // Footer
    poweredBy: 'powered by',
    SITE_ENGIS_DIVISION: 'Division Engis',
    SITE_MONSIN_DIVISION: 'Division Monsin',
    ENTRIES_PROCESS: 'Entrées',
    EXITS_PROCESS: 'Sorties'
  }
};
